class UpdateBiodataUseCase {
    /**
     * @param {BiodataRepository} biodataRepository
     */
    constructor(biodataRepository) {
        this.biodataRepository = biodataRepository;
    }

    /**
     * @param {string} biodataId
     * @param {object} updates
     * @returns {Promise<void>}
     */
    async execute(biodataId, updates) {
        return this.biodataRepository.updateBiodata(biodataId, updates);
    }
}

export default UpdateBiodataUseCase;
